import {Outlet} from 'react-router-dom';
import {ErrorBoundary, Header, SideNavigation} from '@/components';
import {Breadcrumbs} from './components';
import styles from './primary.module.scss';

export const PrimaryPage = () => (
  <section className={styles.primaryLayout}>
    <ErrorBoundary message="'Header' is not available at this time. Please update later">
      <Header />
    </ErrorBoundary>
    <section className={styles.siteLayout}>
      <ErrorBoundary message="'SideNavigation' is not available at this time. Please update later">
        <SideNavigation />
      </ErrorBoundary>
      <main className={styles.content}>
        <ErrorBoundary message="'Breadcrumbs' is not available at this time. Please update later">
          <Breadcrumbs />
        </ErrorBoundary>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </section>
  </section>
);
